import { useState } from 'react'
import { router } from '@inertiajs/react'
import StepBadge from './StepBadge'
import FileDropZone from './FileDropZone'
import FilePreview from './FilePreview'
import FileMetadataPanel from './FileMetadataPanel'

export interface UploadedFile {
  url: string
  content_type: string
  filename: string
  byte_size?: number
  created_at?: string
}

interface Props {
  uploadedFile: UploadedFile | null
  uploadUrl: string
  onExtract: () => void
  extracting: boolean
}

export default function UploadedFileCard({ uploadedFile, uploadUrl, onExtract, extracting }: Props) {
  const [uploading, setUploading] = useState(false)

  function uploadFile(file: File) {
    setUploading(true)
    router.post(uploadUrl, { file }, {
      forceFormData: true,
      onFinish: () => setUploading(false),
    })
  }

  return (
    <div className="bg-white border border-gray-200 rounded-2xl flex flex-col overflow-hidden">
      <div className="flex items-center gap-3 px-6 py-4 border-b border-gray-200">
        <StepBadge n={1} />
        <h2 className="text-gray-900 font-semibold text-base">Uploaded File</h2>
      </div>

      {uploadedFile ? (
        <div className="flex flex-col sm:flex-row flex-1 divide-y sm:divide-y-0 sm:divide-x divide-gray-200">
          <FilePreview uploadedFile={uploadedFile} />
          <FileMetadataPanel
            uploadedFile={uploadedFile}
            onUpload={uploadFile}
            uploading={uploading}
            onExtract={onExtract}
            extracting={extracting}
          />
        </div>
      ) : (
        <FileDropZone onUpload={uploadFile} uploading={uploading} />
      )}

      <div className="flex items-center gap-2 px-6 py-3 border-t border-gray-200 bg-gray-50">
        <svg className="w-3.5 h-3.5 text-gray-400 shrink-0" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor">
          <path strokeLinecap="round" strokeLinejoin="round" d="M16.5 10.5V6.75a4.5 4.5 0 1 0-9 0v3.75m-.75 11.25h10.5a2.25 2.25 0 0 0 2.25-2.25v-6.75a2.25 2.25 0 0 0-2.25-2.25H6.75a2.25 2.25 0 0 0-2.25 2.25v6.75a2.25 2.25 0 0 0 2.25 2.25Z" />
        </svg>
        <span className="text-gray-400 text-xs">Your files are secure and used only for extraction.</span>
      </div>
    </div>
  )
}
